// removed by extract-text-webpack-plugin
module.exports = {"moment":"moment_1oLia","picked":"picked_2oy1l","focused":"focused_buBof","hover":"hover_2TkD7","autoSize":"autoSize_Z0lz4","label":"label_GoTVT","border":"border_38ms8"};


//////////////////
// WEBPACK FOOTER
// ./app/components/moment/styles.scss
// module id = 477
// module chunks = 1